<template lang="pug">
.landing
  .main-container-wide
    slot(name="top")
    slot(name="replays")
    shorts.top-picks( v-if="playlistId && false" :playlist-id="playlistId" theme="landscape" title="Featured" )
    .schedule(v-if="showSchedule")
      h3 {{__('Schedule Overview', eventNamespace)}}
      event-schedule-scroller(:base-url="baseUrl" :events="events" :competition="competition" :timeZone="timeZone")
  .landing-page
    slot(name="landing-page")
  .main-container-wide
    shorts.shorts(
      v-if="shortsPlaylistId"
      :playlist-id="shortsPlaylistId"
      :title="shortsTitle"
    )
    .feat-product(v-for="list in featuredProductLists" :key="list.headerText")
      h3 {{ __(list.headerText, 'auto')  }}
      AdvancedProductList(:productIds="list.products")
</template>
<script setup lang="ts">
import { inject } from 'vue'
import { eventNamespace } from '../../js/constants'
import EventScheduleScroller from './EventScheduleScroller.vue'

interface Competition {
  baseUrl?: string;
  hidePastSchedule?: boolean;
  [key: string]: any;
}

const props = withDefaults(defineProps<{
  playlistId?: string
  premiumPrice?: string
  shortsPlaylistId?: string
  shortsTitle?: string
  baseUrl?: string
  showSchedule?: boolean
  events?: any[]
  competition: Competition
  featuredProductLists?: any[]
  timeZone?: string
}>(), {
  premiumPrice         : '$20',
  shortsTitle          : 'Highlights',
  baseUrl              : '',
  showSchedule         : false,
  events               : () => [],
  competition          : () => ({}),
  featuredProductLists : () => [],
  timeZone             : '',
})

const showOverlay = inject('showOverlay', () => {})

</script>
<style lang="scss" scoped>
.top-picks, .schedule, .shorts, .feat-products {
  margin-bottom: $space-xxxl;
}
</style>
